import { useAuth } from '../../auth/hooks/useAuth';

export const useAdmin = () => {
  const { user, loading } = useAuth();
  return {
    isAdmin: user?.isAdmin ?? false,
    isLoading: loading,
  };
};
